.bigPlay {
  position: absolute;
  inset: 0;
  z-index: 1;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: opacity 0.3s ease;
}

.hidden {
  opacity: 0;
  pointer-events: none;
}

.icon {
  width: 76px;
  height: 76px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.icon svg {
  width: 76px;
  height: 76px;
  fill: rgba(255, 255, 255, 0.8);
  filter: drop-shadow(0 2px 8px rgba(0, 0, 0, 0.5));
  transition: fill 0.15s ease;
}

.bigPlay:hover .icon svg {
  fill: #fff;
}
